/**
 * Mapeamento de cores por operadora
 * Cores consistentes em modo claro e escuro
 */
export const OPERADORA_COLORS: Record<string, string> = {
  'CLARO': 'bg-danger/5 text-danger border-danger dark:bg-danger/30 dark:text-danger dark:border-danger',
  'VIVO': 'bg-purple-50 text-purple-700 border-purple-300 dark:bg-purple-950/30 dark:text-purple-400 dark:border-purple-800',
  'TIM': 'bg-info/5 text-info border-info dark:bg-info/30 dark:text-info dark:border-info',
  'OI': 'bg-warning/5 text-warning border-warning dark:bg-warning/30 dark:text-warning dark:border-warning',
  'ALGAR': 'bg-warning/5 text-warning border-warning dark:bg-warning/30 dark:text-warning dark:border-warning',
  'SERCOMTEL': 'bg-warning/5 text-warning border-warning dark:bg-warning/30 dark:text-warning dark:border-warning',
  'NEXTEL': 'bg-warning/5 text-warning border-warning dark:bg-warning/30 dark:text-warning dark:border-warning',
  'DESCONHECIDO': 'bg-warning/5 text-warning border-warning dark:bg-warning/30 dark:text-warning dark:border-warning',
};

/**
 * Retorna as classes CSS de cor para uma operadora
 * @param operadora - Nome da operadora
 * @returns Classes Tailwind CSS para aplicar no Badge
 */
export function getOperadoraColor(operadora: string): string {
  if (!operadora) return OPERADORA_COLORS['DESCONHECIDO'];
  
  const operadoraUpper = operadora.toUpperCase();
  return OPERADORA_COLORS[operadoraUpper] || OPERADORA_COLORS['DESCONHECIDO'];
}

/**
 * Formata nome da operadora para exibição
 * @param operadora - Nome da operadora
 * @returns Nome formatado
 */
export function formatOperadora(operadora: string): string {
  if (!operadora) return 'Desconhecido';
  
  const map: Record<string, string> = {
    'CLARO': 'Claro',
    'VIVO': 'Vivo',
    'TIM': 'TIM',
    'OI': 'Oi',
    'ALGAR': 'Algar',
    'SERCOMTEL': 'Sercomtel',
    'NEXTEL': 'Nextel',
  };
  
  return map[operadora.toUpperCase()] || operadora;
}
